<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col
        cols="11"
        class="mx-auto"
      >
        <p 
          :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
          :align="mobile() ? 'center' : 'left'"
        >
          {{ $t('targetGroupsTitle') }}
        </p>
        <p class="text-body-1 greytext--text d-none d-sm-block">
          {{ $t('targetGroupsText') }}
        </p>
      </v-col>
    </v-row>
    <v-row
      v-if="(!targetGroups || targetGroups.length == 0) && targetGroupsInfo.currentPage == 1 && !loadingData"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptytargetGroupsPageTitle')"
          :page-text="$t('emptytargetGroupsPageText')"
          page-image="image1"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="targetGroups.length > 0 && !loadingData"
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <v-card
          v-for="(targetGroup,index) in targetGroups"
          :key="targetGroup.id"
          :ripple="false"
          data-testid="target-group-card"
          rounded="xxl"
          class="my-2 solo"
          @click="showTargetGroupDetail(targetGroup.id)"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="11"
                align-self="center"
                class="px-6"
              >
                <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ targetGroup.attributes.name }}
                </v-card-text>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  ref="menuRef"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list">
                    <v-list-item
                      data-testid="edit-tg-item"
                      router
                    >
                      <v-list-item-title> 
                        <EditTargetGroup
                          :target-group-name="targetGroup.attributes.name"
                          :target-group-id="targetGroup.id"
                          :target-group-index="index"
                          @proceedSubmit="updateTargetGroup"
                          @closeMenu="closeMenu"
                        />
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="delete-tg-item"
                      router 
                      @click.stop="
                        selectedTargetIdForDeletion= targetGroup.id,
                        dialogVisible=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleDeleteTargetGroup'), 
                        confirmationDialogText=$t('confirmationDialogTextDeleteTargetGroup'), 
                        confirmationDialogSubmitBtn=$t('delete')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="12"
                md="11"
                class="px-6"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('targetGroup') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ targetGroup.attributes.name }}
                </div>
              </v-col>
              <v-col
                cols="12"
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  ref="menuRef"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list">
                    <v-list-item
                      data-testid="edit-tg-item"
                      router
                    >
                      <v-list-item-title> 
                        <EditTargetGroup
                          :target-group-name="targetGroup.attributes.name"
                          :target-group-id="targetGroup.id"
                          :target-group-index="index"
                          @proceedSubmit="updateTargetGroup"
                          @closeMenu="closeMenu"
                        />
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="delete-tg-item"
                      router 
                      @click.stop="
                        selectedTargetIdForDeletion= targetGroup.id,
                        dialogVisible=true,
                        confirmationDialogTitle=$t('confirmationDialogTitleDeleteTargetGroup'),
                        confirmationDialogText=$t('confirmationDialogTextDeleteTargetGroup'),
                        confirmationDialogSubmitBtn=$t('delete')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="targetGroups.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="targetGroupsInfo.total"
      :page-number="targetGroupsInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
    <PlusButtonWithLink
      data-testid="create-new-target-group-button"
      rounded="xxl"
      :link="link"
      :hide-for-free-plan="productPlan.attributes && productPlan.attributes.name == 'Free'"
    />

    <ConfirmationDialog
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog" 
      @close="dialogVisible=false"
      @proceedSubmit="deleteTargetGroup(selectedTargetIdForDeletion)"
    />
  </nav>
</template>    
<script>
import i18n from '../../plugins/i18n'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import Pagination from '../../components/Pagination'
import EmptyPage from '../../components/EmptyPage'
import { getTargetGroups, deleteTargetGroup } from '../../api/targetGroupApi'
import EditTargetGroup from './EditTargetGroup'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: { 
        PlusButtonWithLink,
        EmptyPage,
        Pagination,
        EditTargetGroup,
        ConfirmationDialog,
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            targetGroups: [],
            link: {title: i18n.t('createTargetGroupTitle'), route: '/target-groups/create'},
            alertType: '',
            alertMsg: '',
            alertValue:false,
            targetGroupsInfo: {
              currentPage: 1,
              total: 1,
            },
            spaceId: window.$cookies.get('space_id'),
            pageNumber: 1,
            size: 15,
            loadingData: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            dialogVisible: false,
            selectedTargetIdForDeletion: '',
            paginationKey: ''
        }
    },
    computed: {
        filteredItems(){
             return this.targetGroups.filter((item) =>{
                if(!this.searchTerm) return this.targetGroups
                return item.name.toLowerCase().match(this.searchTerm.toLowerCase())
            })
        },
        paginatedData() {
            const start = this.pageNumber * this.size - this.size,
            end = start + this.size
            return this.filteredItems.slice(start, end)
        },
        productPlan() {
            return this.$store.state.productPlan;
        },
    },
    async created(){
        if(this.$route.params.successfullyCreatedTargetGroup){ 
            this.alertType = 'success'    
            this.alertMsg = i18n.t('newTargetGroupMsg')
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedTargetGroup){     
            this.alertType = 'success'    
            this.alertMsg = i18n.t('deleteTargetGroupSuccess')
            this.alertValue = true
        }
        this.loadingData = true
        await this.fetchTargetGroups()
        this.loadingData = false
    },
    methods: {
        showTargetGroupDetail(id){
            this.$router.push({path: '/target-group/' + id })
        },
        handlePageChange(value){
            this.targetGroupsInfo.currentPage = value
            this.pageNumber = value
            this.fetchTargetGroups()
        },
        async fetchTargetGroups(){
            try {
                const response = await getTargetGroups(this.spaceId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.targetGroups = response.data.data
                        if(this.targetGroups.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.fetchTargetGroups()
                        }else {
                          this.targetGroupsInfo = response.data.meta.page
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          window.scrollTo(0,0)
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
        updateTargetGroup(msg, type, name, index){
            this.alertType= type
            this.alertMsg = msg
            if(this.targetGroups[index]){
                this.alertValue = true
                this.targetGroups[index].attributes.name = name
                this.closeMenu(index)
            }
        },
        closeMenu(index){
            this.$refs.menuRef[index].isActive = false
        },
        async deleteTargetGroup(id){
            this.alertMsg=''
            this.dialogVisible = false
            try{
                let data = {
                    data: {
                        type: "target-groups", 
                        id: id,
                        attributes: {
                            deleted_at: this.currentDate()
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            }
                        }
                    }
                }
                const response = await deleteTargetGroup(id, data)
                if(response.status == 200) {
                    await this.fetchTargetGroups()
                    this.alertType = 'success'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('deleteTargetGroupSuccess')
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            this.alertValue = true
                            if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                this.$router.push({name: 'PageAccessDenied'})
                            }
                            else {
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError')
                            }
                        }
                    } else{
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        }
    },
}
</script>
